// extracted by mini-css-extract-plugin
module.exports = {"code":"KtOrderHeader_code__2Tnzl","splited":"KtOrderHeader_splited__2YbP2"};